import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import FeeScheduleCategoryCommand from "marketplace/teams/fee-schedules/_api/commands/fee-schedule-category-command";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";

export default class UpdateFeeScheduleTemplateCommand {
  public payload: JsonPatchOperation[] = [];

  constructor(originalTemplate: FeeScheduleTemplate, updatedTemplate: FeeScheduleTemplate) {
    if (updatedTemplate.name !== originalTemplate?.name)
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updatedTemplate.name,
      });
    if (updatedTemplate.tags !== originalTemplate?.tags)
      this.payload.push({
        op: "replace",
        path: "/tags",
        value: updatedTemplate.tags.map((tag) => tag.value),
      });
    if (updatedTemplate.categories !== originalTemplate?.categories) {
      this.payload.push({
        op: "replace",
        path: "/categories",
        value: updatedTemplate.categories.map((category) => new FeeScheduleCategoryCommand(category)),
      });
    }
  }
}
